import { Routes } from '@angular/router';

import { pricelistManagementSegments } from '@advania-cosoftware/wolf-router';

export const pricelistManagementRoutes: Routes = [
    {
        path: pricelistManagementSegments.pricelistManagement,
        loadComponent: () =>
            import('./features/home/pricelist-management-home/pricelist-management-home.page').then(
                (m) => m.PricelistManagementHomePage,
            ),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: pricelistManagementSegments.pricelist,
            },
            {
                path: pricelistManagementSegments.pricelist,
                loadComponent: () =>
                    import('./features/home/pricelist-list/pricelist.page').then((m) => m.PricelistPage),
            },
            {
                path: pricelistManagementSegments.listPrices,
                loadComponent: () =>
                    import('./features/home/list-prices/list-prices.page').then((m) => m.ListPricesPage),
            },
            {
                path: pricelistManagementSegments.customerPrices,
                loadComponent: () =>
                    import('./features/home/customer-prices/customer-prices.page').then((m) => m.CustomerPricesPage),
            },
            {
                path: pricelistManagementSegments.indexAdjustments,
                loadComponent: () =>
                    import('./features/home/index-adjustments/index-adjustments.page').then(
                        (m) => m.IndexAdjustmentsPage,
                    ),
            },
            {
                path: `${pricelistManagementSegments.indexAdjustments}/:${pricelistManagementSegments.batchId}`,
                loadComponent: () =>
                    import('./features/home/index-adjustment-detail/index-adjustment-detail.page').then(
                        (m) => m.IndexAdjustmentDetailPage,
                    ),
            },
        ],
    },
];
